import {
  addLanguageToPath,
  isChinaDomainClient,
  shouldAddLanguagePrefix,
  extractLanguageFromPath,
} from "@Utils/languageCore";

interface ICustomWindowLocationParams {
  url: string;
  isExternal?: boolean;
  replace?: boolean;
}

/**
 * Utility function for window.location navigation with language routing
 * Use this in non-React contexts (e.g., Redux thunks, utility functions)
 * For React components, use the useCustomWindowLocation hook instead
 *
 * @param url - The URL to navigate to
 * @param isExternal - If true, navigates to URL as-is without language prefix
 * @param replace - If true, uses location.replace instead of location.href (no history entry)
 */
export const customWindowLocation = ({
  url,
  isExternal = false,
  replace = false,
}: ICustomWindowLocationParams): void => {
  if (!url) return;

  // Get user language from window.__INITIAL_STATE__ (same pattern as customHistoryPush)
  const { appData }: any = window.__INITIAL_STATE__;
  const isChinaDomain = isChinaDomainClient();
  const userLanguage = isChinaDomain
    ? extractLanguageFromPath(window.location.pathname) || appData?.userLanguage || "zh"
    : appData?.userLanguage || "en";
  const finalUrl =
    !isExternal && (!isChinaDomain || shouldAddLanguagePrefix(userLanguage))
      ? addLanguageToPath(url, userLanguage)
      : url;

  if (replace) {
    window.location.replace(finalUrl);
  } else {
    window.location.href = finalUrl;
  }
};

export default customWindowLocation;
